var map = {
	"./15m_sprint.svg": "36d2",
	"./15m_sprint_card.svg": "b268",
	"./ball_wall.svg": "3a94",
	"./ball_wall_card.svg": "59ef",
	"./catching.svg": "4a6d",
	"./catching_card.svg": "2e09",
	"./cooper_run.svg": "35a7",
	"./cooper_run_card.svg": "23ec",
	"./football_dribbling.svg": "4f51",
	"./football_dribbling_card.svg": "d9d0",
	"./handeye.svg": "0b65",
	"./handeye_card.svg": "48d5",
	"./keepy_uppy.svg": "fde3",
	"./keepy_uppy_card.svg": "c687",
	"./logo_vertical.svg": "e715",
	"./long_jump.svg": "1d86",
	"./long_jump_card.svg": "6736",
	"./parnter_work.svg": "8a4e",
	"./parnter_work_card.svg": "6b9c",
	"./plank.svg": "3cc5",
	"./plank_card.svg": "5f6a",
	"./pushup.svg": "b0a0",
	"./pushup_card.svg": "4b65",
	"./reaction.svg": "9d65",
	"./reaction_card.svg": "08a2",
	"./shuttle_run.svg": "a083",
	"./shuttle_run_card.svg": "1548",
	"./sit_reach.svg": "6c0e",
	"./sit_reach_card.svg": "cbf3",
	"./situp.svg": "6ad2",
	"./situp_card.svg": "2b65",
	"./skipping.svg": "c284",
	"./skipping_card.svg": "982c",
	"./speed_bounce.svg": "3215",
	"./speed_bounce_card.svg": "eb74",
	"./stepup.svg": "02df",
	"./stepup_card.svg": "3c44",
	"./stork_balance.svg": "24af",
	"./stork_balance_card.svg": "83cf"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7af0";